const ReserveLogo = ({ width = 34, height = 40 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5424_9408)">
        <path
          d="M0.800049 36.8V38.4L9.60005 39.2L18.4 38.4V36.8L9.60005 37.6L0.800049 36.8Z"
          fill="white"
        />
        <path
          d="M0.709961 33.42V35.02H9.59996H18.49V33.42H9.59996H0.709961Z"
          fill="white"
        />
        <path
          d="M0.620117 30.04V31.64L9.60012 30.84L18.5801 31.64V30.04L9.60012 29.24L0.620117 30.04Z"
          fill="white"
        />
        <path
          d="M26.66 13.64L33.32 18.09V16.44L26.66 12L21.29 15.58L19.2 6.4L9.6 0L0 6.4V8L9.6 1.6L19.11 7.94L19.07 9.75L9.6 4.18L0.09 9.78V11.38L9.6 5.78L19.03 11.33L18.99 13.14L9.6 8.36L0.18 13.16V14.76L9.6 9.96L18.95 14.72L18.91 16.52L9.6 12.53L0.27 16.53V18.13L9.6 14.13L18.87 18.11L18.82 19.9L9.6 16.71L0.36 19.91V21.51L9.6 18.31L18.79 21.49L18.74 23.29L9.6 20.89L0.44 23.29V24.89L9.6 22.49L18.7 24.88L18.66 26.67L9.6 25.07L0.53 26.67V28.27L9.6 26.67L18.62 28.26L18.6 29.16L20.55 38.65L26.66 39.2L32.77 38.65V37.28L26.66 37.84L26.34 37.81L25.84 35.57L26.66 35.55L32.85 35.71V34.31L26.66 34.15L25.52 34.18L25.05 32.12L26.66 31.9L32.93 32.77V31.33L26.66 30.46L24.73 30.73L24.3 28.84L26.66 28.25L33.01 29.83V28.35L26.66 26.77L23.98 27.43L23.59 25.7L26.66 24.6L33.09 26.9V25.37L26.66 23.07L23.27 24.29L22.91 22.69L26.66 20.95L33.16 23.96V22.4L26.66 19.38L22.58 21.27L22.25 19.79L26.66 17.3L33.24 21.02V19.42L26.66 15.69L21.92 18.37L21.61 17.01L26.66 13.64Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5424_9408">
          <rect width="33.32" height="39.2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ReserveLogo };
